import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Menu, MenuItem } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "../../assets/ic-close.svg";
import IconHelp from "../../assets/ic-help.svg";
import { ReactComponent as MenuIcon } from "../../assets/ic-menu.svg";
import IconMyAccount from "../../assets/ic-myAccount.svg";
import IconShoppingCart from "../../assets/ic-shoppingCart.svg";
import theme from "../../theme";
import Button from "../Button";
import Logo from "../Logo";
import Space from "../Space";
import TextButton from "../TextButton";
import Typography from "../Typography";
import { MOBILE_NAVBAR_HEIGHT } from "./constant";
import CartIcon from "./CartIcon";
import { useLocation } from "react-router-dom";
import WhatsAppUsEn from "../../assets/whatsApp_us_en.svg";
import WhatsAppUsTc from "../../assets/whatsApp_us_tc.svg";

const StyledTypography = styled(Typography)`
  font-weight: 500;
  text-align: center;
  color: ${theme.lightBlack};
  font-size: 18px;
`

const CustomButton = styled(Button)`
  && {
    margin-right: 20px;
    width: 200px;
    height: 45px;
  }
`;

const StyledMenu = ({ top = MOBILE_NAVBAR_HEIGHT, height = "fit-content", children, ...props }) => {
  return (
    <Menu
      PaperProps={{
        sx: {
          top: `${top}px !important`,
        },
        style: {
          width: "100%",
          maxWidth: "100%",
          height: height,
          left: 0,
          right: 0,
        },
      }}
      id="menu-appbar"
      keepMounted
      anchorOrigin={{ vertical: "top", horizontal: 'left' }}
      transformOrigin={{ vertical: "top", horizontal: 'left' }}
      marginThreshold={0}
      {...props}
    >
      {children}
    </Menu>
  )
}

function MenuBar(props) {
  const {
    handleHelp,
    handleChangeLanguage,
    handleCart,
    handleClickMenuItem,
    handleClickMenuParentItem,
    handleClickMenuSubItem,
    menuItem,
    userMenuItem,
    consentHeight,
  } = props;

  const { t, i18n } = useTranslation(["navBar", "home"]);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorLogin, setAnchorLogin] = useState(null);
  const [isExpand, setIsExpand] = useState('');

  const location = useLocation();

  // close all menu when window.pathname change
  useEffect(() => {
    setAnchorElUser(null);
    setAnchorLogin(null);
  }, [location])

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
    setAnchorLogin(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOnClickParentItem = (itemId) => {
    if (isExpand !== itemId) setIsExpand(itemId);
    else setIsExpand('');
  }

  return (
    <React.Fragment>
      <AppBar position="static" sx={{ backgroundColor: "#fff", color: "#000", minHeight: MOBILE_NAVBAR_HEIGHT, position: "relative", justifyContent: "center" }}>
        <Toolbar variant="dense" style={{ padding: "7px 10px", display: "flex", justifyContent: "space-between", gap: 15 }}>
          <div style={{ flex: 1 }}>
            <Logo style={{ textDecoration: "none", padding: "9px 15px 7px 10px" }} onClick={() => handleClickMenuItem({ id: 'website-logo', href: '/' })} />
          </div>
          <div style={{ display: "flex", flexWrap: "nowrap", gap: "16px", alignItems: "center" }}>
            {/* <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleCart}
            >
              <img src={IconShoppingCart} />
            </IconButton> */}
            <CartIcon onClick={handleCart} style={{ maxHeight: 27 }} />

            <IconButton
              onClick={() => {
                setAnchorLogin((prev) => !prev);
                setAnchorElUser(null);
              }}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <img src={IconMyAccount} />
            </IconButton>

            <IconButton
              onClick={anchorElUser ? handleCloseUserMenu : handleOpenUserMenu}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              {anchorElUser ? <CloseIcon style={{ width: "22px" }} /> : <MenuIcon style={{ width: "22px" }} />}
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      {/* Menu for My Account */}
      <StyledMenu
        top={MOBILE_NAVBAR_HEIGHT + consentHeight}
        anchorEl={anchorLogin}
        open={Boolean(anchorLogin)}
        onClose={() => setAnchorLogin(null)}
      >
        {
          userMenuItem.map((item) => {
            return (
              <MenuItem
                key={`mobile-menu-item-${item.id}`}
                onClick={() =>
                  handleClickMenuSubItem(
                    { id: "my-account", child: userMenuItem },
                    item,
                    setAnchorLogin(null),
                  )
                }
              >
                <StyledTypography>
                  <TextButton
                    color={theme.lightBlack}
                    startIcon={item?.icon || null}
                  >
                    {t(`topBar.${item?.label}`)}
                  </TextButton>
                </StyledTypography>
              </MenuItem>
            )
          })
        }
        <Space size={30} />
      </StyledMenu>

      {/* Menu for navigation */}
      <StyledMenu
        height="100%"
        top={MOBILE_NAVBAR_HEIGHT + consentHeight}
        anchorEl={anchorElUser}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {
          menuItem.map((parent) => {
            if (parent?.child && parent?.child?.length > 0) {
              const isCurrentExpand = isExpand === parent.id;

              return (
                <div>
                  <MenuItem
                    key={`mobile-menu-parent-${parent.id}`}
                    onClick={() => handleClickMenuParentItem(parent, handleOnClickParentItem(parent.id))}
                    style={{ display: "flex", justifyContent: "space-between", padding: "20px" }}
                  >
                    <StyledTypography>
                      {t(`navBar:topBar.${parent?.label}`)}
                    </StyledTypography>
                    {isCurrentExpand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </MenuItem>

                  {isCurrentExpand && (
                    parent.child.map((item, index) => (
                      <MenuItem
                        key={`mobile-menu-sub-item-${item.id}`}
                        onClick={() => {
                          const handleClick = () => {
                            handleCloseUserMenu();
                            parent?.onClickChild && parent?.onClickChild();
                          }
                          handleClickMenuSubItem(parent, item, handleClick);
                        }}
                      >
                        <TextButton color={theme.navSubItem} startIcon={item.icon} fontWeight={500}>
                          {t(`home:${item.id}`)}
                        </TextButton>
                      </MenuItem>
                    ))
                  )}
                </div>
              )
            } else {
              return (
                <MenuItem
                  key={`mobile-menu-item-${parent.id}`}
                  onClick={() => handleClickMenuItem(parent, handleCloseUserMenu)}
                  style={{ padding: "20px" }}
                >
                  <StyledTypography>
                    {t(`navBar:topBar.${parent?.label}`)}
                  </StyledTypography>
                </MenuItem>
              )
            }
          })
        }

        <MenuItem
          key={"lang"}
          onClick={handleChangeLanguage}
          style={{ padding: "20px" }}
        >
          <StyledTypography>
            {t("navBar:topBar.mobileLang")}
          </StyledTypography>
        </MenuItem>

        <div
          style={{
            display: "flex",
            padding: "6px 20px",
            // marginTop: "20px",
          }}
        >
          {
            // <CustomButton
            // startIcon={<img src={IconHelp} />}
            // onClick={handleHelp}
            // >
            //   {t("topBar.contactUs")}
            // </CustomButton>
            <img
              src={(i18n?.language === 'en') ? WhatsAppUsEn: WhatsAppUsTc}
              alt={t("topBar.contactUs")}
              style={{ height: 45, cursor: "pointer" }}
              onClick={handleHelp}
            />
          }
        </div>
      </StyledMenu>
    </React.Fragment>
  );
}

export default MenuBar;
